<div class="modal-header py-2">
    <h2 class="mb-0">Reactivate subscription</h2>
    <span class="icon icon-cross ml-auto py-1 px-2" (click)="cancel()"></span>
</div>
<div class="modal-body">
    <p>Reactivate your subscription</p>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary mr-2"
        angularticsCategory="account"
        angulartics2On="click"
        angularticsAction="Confirm reactivate subscription"
        type="submit"
        [disabled]="inProgress"
        (click)="reactivate()"
    >Confirm</button>
    <button type="button" class="btn btn-danger" [disabled]="inProgress" (click)="cancel()">Cancel</button>
</div>
